// extracted by mini-css-extract-plugin
module.exports = {"container":"App_container__y83D3","image":"App_image__3YhPC"};